import CalendarIcon from 'assets/calendar.svg?react'
import { format } from 'date-fns'

import { Value } from '.'
import classes from './index.module.scss'

interface Props {
  value: Value | null
}
export const DisplayedValue = ({ value }: Props) => (
  <div className={classes.displayedValue}>
    <span className={classes.iconWrapper}>
      <CalendarIcon />
    </span>
    <span className={classes.formattedDate}>
      {value && Array.isArray(value)
        ? `${format(new Date(value[0]), 'd MMMM yyyy')} - ${format(
            new Date(value[1]),
            'd MMMM yyyy'
          )}`
        : format(value as Date, 'd MMMM yyyy')}
    </span>
  </div>
)
